<template>

  <v-dialog
    v-model="show"
     transition="dialog-bottom-transition"
    persistent
    :width="420"
    >
    <div style="background: #f0f0f0; padding: 6px;">
    <v-toolbar class="ma-1"  dense  elevation="0" rounded>
            <v-icon left >mdi-playlist-plus</v-icon><span class="va-underline">{{action=='new'?'New':'Modify'}} Product </span>
            <v-spacer/>
            <v-btn fab x-small elevation="1" color="warning"  @click="emitToParent('close')"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
    <v-row no-gutters>
      <v-col cols="12">
          <v-card class="ma-1">
            <v-card-text>
              <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
                    <v-text-field
                      v-model="product.name"
                      outlined
                      @change="validateName()"
                      dense
                      :rules="FieldRules('Please enter a product name')"
                      label="Product Name"
                    />
                    <v-text-field
                      outlined
                      dense
                       v-model="product.code"
                      label="Product Code"
                    />
                    <v-select
                    v-model="product.type"
                      :items="types"
                      label="Category"
                      :rules="FieldRules('Select Category')"
                      outlined
                      dense
                    ></v-select>
                    <v-textarea
                      outlined
                       rows="2"
                       v-model="product.description"
                      label="Description"
                      dense
                    />
                   

                   
                    <v-combobox
                      v-model="product.tags"
                      label="Product tags"
                      flat
                      labels
                      dense
                      chips
                      multiple
                      :rules="FieldRules('Please enter a product tags')"
                      outlined
                      
                    ></v-combobox>
            
                    <v-select
                    v-model="product.status"
                      :items="['Available', 'Not Available']"
                      label="Status"
                      :rules="FieldRules('Select status')"
                      outlined
                      dense
                    ></v-select>
                    <v-divider/>
                  <div >
                   
                  </div>  
                  
                 
             </v-form>
             </v-card-text> 
          </v-card>
      </v-col>
     
      <v-col cols="12" class="pa-1"> 
     <v-bottom-navigation>
      
      <v-btn  @click="emitToParent('close')">
        <v-icon>mdi-close</v-icon>

        <span>Close</span>
      </v-btn>

      <v-btn value="nearby"  @click="validate()" color="success" :disabled="disabled">
        <v-icon color="#fff">mdi-{{action=='new'?'note-plus-outline':'check'}}</v-icon>

        <span class="text-white">{{action=='new'?'Add Product':'Modify'}}</span>
      </v-btn>
    </v-bottom-navigation>
      </v-col>

    </v-row>      
  </div>

  </v-dialog>

</template>

<script>
 import {
   mapMutations
 } from 'vuex'
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    selectedID: {
       type: Number,
        default: null
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      showprop: false,
      showsku: false,
      skustate:'new',
      valid: true,
      bottomNav: false,
      s3upload: false,
      newpassword:'',
      disabled: false,
      loading: false,
      latlong:{},
      product:{},
      product_statuses:[],
      product_items:[],
      productID:0,
      types: [],
      action: 'new',
      selected_item:{}
  }),
  computed: {

  },
  watch: {
    show (v) {
      if (v) {
          this.product_statuses = this.GET_SYSVARS('product_status')
          this.types = this.GET_SYSVARS('product_types')
          this.action = this.state
          
         
      }  else {  

        this.$refs.form.reset()
        this.setActionAlert({show: false, text: ""});
      }
    
    }
  },
  methods: {
    ...mapMutations(['setActionAlert']),
    skuEv(){
      this.showsku = false
      this.getItems()
    },
    propEv(props){
      this.showprop = false
      if(this.action == 'new') {
          this.product.properties = props
      } else {
        this.getProduct()
      }
      
    },
    validateName(){
     if(this.product.name.length > 3) {
      this.s3upload = true
      this.bottomNav = true
     }
     
    },
    validate () {
       
        if (this.$refs.form.validate()) {
            if(this.action=='new') {
              this.addProduct()
            } else {
              this.updateProduct()
            }
            
        }
      },
      s3Ev(e){
        this.s3upload = false
        if(this.product.images == null) {
          this.product.images = e
        } else {
          this.product.images = this.product.images.concat(e);
        }
      },
      saveItem(item){
      this.$http.post("product/update_item", item).then(response => {
        this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
        this.getItems()
      }).catch(e => {
        console.log(e.data)
      })
    },
      getItems(){
        this.GET_PRODUCT_ITEMS(this.productID, (res)=>{
          if(res.rows>0){
            this.product_items = res.items
          }
        })
      },
      getProduct(){
        this.VA_ALERT('info', 'Loading product...', 'progress', 100, 2000)
        this.SINGLE_PRODUCT(this.productID, (res)=>{
          if(res.rows>0){
            this.product = res.items[0]
            if(!this.product.images) {
              this.product.images =[]
            }
            this.getItems()
          }
        })
      },
      addProduct() { 
          this.disabled=true
        console.log("New product", this.product)
        this.product.added_by = this.$IsNum(this.$session.get('userID'))
        this.$http.post("new_product", this.product).then(response => {
          console.log("add", response)
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
          this.disabled=false
          if(response.data.status){
          this.emitToParent()
          }
        }).catch(e => {
          this.disabled=false
          console.log(e.data)
        })
     },
     updateProduct() { 
        this.disabled=true
        this.$http.post("product/update", this.product).then(response => {
          console.log("add", response.data)
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
          this.disabled=false
          if(response.data.status){
            this.action = "update"
            this.getProduct()
          }
        }).catch(e => {
          this.disabled=false
          console.log(e.data)
        })
     },
      emitToParent () {
          this.$emit('DialogEvent', "")
      }
  }
}
</script>
